export enum SurfaceType {
  HIGHLIGHT = 'highlight',
  PROJECT = 'project',
}

export interface LikeRequestDTO {
  surfaceType: SurfaceType
  referencedId: string
  page?: number
}

export interface Like {
  createdOn: number
  id: string
  ownerId: string
  referencedId: string
  surfaceType: SurfaceType
  updatedOn: number
  userWhoLikedId: string
}

export interface ILikeThisRequestDTO {
  surfaceType: SurfaceType
  referencedId: string
}

export enum LikesQueryKeys {
  LIKES = 'likes',
}

export interface LikesResponseDTO {
  numberOfResults: number
  likes: Like[]
  page: number
}
